import { useTranslation } from 'next-i18next'
import Reveal from '../../home-new/Reveal'
import styles from './AboutHero.module.scss'

// Hero for /about?new (design mockup: new-design-other/aboutus/single.png).
// Styling migrated from makeStyles/emotion-JSS to a static CSS Module
// (AboutHero.module.scss) — zero runtime CSS-in-JS, values mirrored from
// tokens.js. Visual output is unchanged. See the module file for the layout
// notes that used to live in this makeStyles block.
const AboutHero = () => {
  const { t } = useTranslation('about-us')

  return (
    <section className={styles.root}>
      <div className={styles.overlay}>
        <div className={`${styles.container} ${styles.overlayInner}`}>
          <div className={styles.copy}>
            <Reveal direction="left">
              <h1 className={styles.heading}>
                {t('about.new.hero.title-prefix')}{' '}
                <span className={styles.gradWord}>SHIPPOP</span>
              </h1>
            </Reveal>
            <Reveal direction="left" delay={0.08}>
              <p className={styles.sub}>{t('about.new.hero.sub')}</p>
            </Reveal>
            <Reveal direction="left" delay={0.14}>
              <p className={styles.desc}>{t('about.new.hero.desc')}</p>
            </Reveal>
            <Reveal direction="up" delay={0.2}>
              <div className={styles.ctaRow}>
                <a href="/service" className={styles.ctaDark}>
                  {t('about.new.hero.cta-service')}
                </a>
                <a href="/contact" className={styles.ctaPrimary}>
                  {t('about.new.hero.cta-contact')}
                </a>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
      <picture>
        <source
          srcSet="/static/img/about-us-new/hero-banner.webp"
          type="image/webp"
        />
        <img
          className={styles.bannerImg}
          src="/static/img/about-us-new/hero-banner.png"
          alt={t('about.new.hero.banner-alt')}
          width={2000}
          height={800}
          fetchpriority="high"
          decoding="async"
        />
      </picture>
    </section>
  )
}

export default AboutHero
